import script from "./ContextMenuGroup.vue?vue&type=script&lang=ts"
export * from "./ContextMenuGroup.vue?vue&type=script&lang=ts"

const __exports__ = script;

export default __exports__